import { render, staticRenderFns } from "./AccountActivityUser.vue?vue&type=template&id=774d4f88&"
import script from "./AccountActivityUser.vue?vue&type=script&lang=js&"
export * from "./AccountActivityUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports